import { LinkableEntityType, LinkedEntityDto } from 'src/Services/API/EntityLinks.api';

// Fixed display order: Souvenirs → Pièces → Objets → Événements → Actions → Documents →
// Dépenses → Projets → Contacts. Ordinary wall messages close the list (see MESSAGE_GROUP).
export const ENTITY_TYPE_ORDER: LinkableEntityType[] = [
  LinkableEntityType.CommunityFeedItem,
  LinkableEntityType.Room,
  LinkableEntityType.InventoryItem,
  LinkableEntityType.Event,
  LinkableEntityType.Task,
  LinkableEntityType.VirtualFile,
  LinkableEntityType.Expense,
  LinkableEntityType.Project,
  LinkableEntityType.Contact,
];

/**
 * A wall item is either a memory album or an ordinary message: both share the
 * communityFeedItem type, but only memories belong in the "Souvenirs" group.
 */
export const MESSAGE_GROUP = 'message';
export type LinkGroupKey = LinkableEntityType | typeof MESSAGE_GROUP;

export const GROUP_ORDER: LinkGroupKey[] = [...ENTITY_TYPE_ORDER, MESSAGE_GROUP];

export const groupKeyOf = (item: LinkedEntityDto): LinkGroupKey =>
  item.entityType === LinkableEntityType.CommunityFeedItem && item.metadata?.kind !== 'memory'
    ? MESSAGE_GROUP
    : item.entityType;

/** Rows shown per group before "Voir les N". */
export const GROUP_PREVIEW_SIZE = 3;
